import React, { useState } from "react";
import { Button, Form, message } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import InputCard from "../../../../../Components/Cards/InputCard";
import { createFuelType } from "../../../../../API/Admin/SystemConfiguration/FuelTypes";
import "../style.css";

const getErrorMessage = (data, fallback) => {
  if (!data) return fallback;
  if (data.message) return data.message;
  if (data.detail) return data.detail;

  const fieldErrors = Object.values(data)
    .flat()
    .filter((msg) => typeof msg === "string");

  return fieldErrors.length ? fieldErrors.join(" ") : fallback;
};

const STATUS_OPTIONS = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

const AddFuelType = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const goToList = () => {
    navigate("/system-configuration", {
      state: { activeTab: "Fuel Types" },
    });
  };

  const handleCancel = () => {
    form.resetFields();
  };

  const fields = [
    {
      name: "name",
      label: "Fuel Type Name",
      type: "text",
      placeholder: "Enter Fuel Type Name",
      rules: [{ required: true, message: "Fuel type name is required" }],
    },
    {
      name: "status",
      label: "Status",
      type: "select",
      placeholder: "Select Status",
      options: STATUS_OPTIONS,
      rules: [{ required: true, message: "Status is required" }],
    },
  ];

  const handleSubmit = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch (error) {
      message.error("Please fill in all required fields.");
      return;
    }

    setSaving(true);
    try {
      const res = await createFuelType({
        name: values.name,
        status: values.status,
      });

      if (Math.floor(res?.status / 100) === 2) {
        message.success(
          getErrorMessage(res?.data, "Fuel type added successfully!"),
        );
        goToList();
      } else {
        message.error(getErrorMessage(res?.data, "Failed to add fuel type."));
      }
    } catch (err) {
      message.error(
        getErrorMessage(err?.response?.data, "Failed to add fuel type."),
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fuel-type-form">
      <div className="back-btn">
        <Button icon={<ArrowLeftOutlined />} onClick={goToList}>
          Back
        </Button>
      </div>
      <div className="title">Add Fuel Type</div>
      <Form form={form} layout="vertical" initialValues={{ status: "active" }}>
        <div className="input-cards-container">
          <InputCard title="General Information" fields={fields} />
        </div>

        <div className="btns-row">
          <Button onClick={handleCancel} disabled={saving}>
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={handleSubmit}
            className="save-btn"
            loading={saving}
            disabled={saving}
          >
            Add Fuel Type
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default AddFuelType;
